import { QueryResult, gql } from '@apollo/client';
import { SerializedHardware, SerializedHardwareItem, SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { notification } from 'antd';
import { useStrapiQuery } from './useStrapiQuery';

const GET_METER_HARDWARE_ITEMS_QUERY = gql`
  query meterHardwareItems($inventoryMeterId: ID!, $categories: [String]) {
    hardwareItems(
      filters: {
        hardware_variants: { is_active: { eq: true }, inventory_meter: { id: { eq: $inventoryMeterId } } }
        hardware: { category: { in: $categories } }
      }
    ) {
      data {
        id
        attributes {
          serial_number
          deactivated_at
          hardware {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export interface GetMeterHardwareItemsQueryResult {
  hardwareItems: {
    data: Array<
      Pick<SerializedHardwareItem, 'serial_number' | 'deactivated_at'> & {
        id: `${SerializedHardwareItem['id']}`;
        hardware: Pick<SerializedHardware, 'name'> & {
          id: `${SerializedHardware['id']}`;
        };
      }
    >;
  };
}

export interface MeterHardwareItemsFilter {
  inventoryMeter?: SerializedInventoryMeter['id'];
  categories?: SerializedHardware['category'][];
}

export const useMeterHardwareItems = (
  filter: MeterHardwareItemsFilter,
): QueryResult<GetMeterHardwareItemsQueryResult> =>
  useStrapiQuery<GetMeterHardwareItemsQueryResult>(GET_METER_HARDWARE_ITEMS_QUERY, {
    variables: {
      inventoryMeterId: filter.inventoryMeter,
      ...(filter.categories && { categories: filter.categories }),
    },
    onError: error => {
      notification.error({
        message: 'Failed to fetch meter hardware items',
        description: error instanceof Error ? error.message : 'Unknown error',
      });
    },
    fetchPolicy: 'network-only',
  });
